import { LoginMethod } from '@mi-front/core';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PasswordIcon from '@mui/icons-material/Password';
import { ReactNode } from 'react';

export const loginMethodIconMap: Record<string, ReactNode> = {
  [LoginMethod.USERNAME_PASSWORD]: <PasswordIcon />,
  [LoginMethod.SOCIAL_LOGIN]: <AccountCircleIcon />,
};
